module.exports = __webpack_public_path__ + "img/no-friends.202f7975.png";